import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, browserHistory, IndexRoute, IndexRedirect, Redirect } from 'react-router';
import { Provider, useSelector } from 'react-redux';
import store from './App/redux/store';
import { initializeBuildFreshness } from './App/diagnostics/buildFreshness';

initializeBuildFreshness();

//Prelogin components
import PreLoginApp from './App/components/PreLogin/App';
import Login from './App/components/PreLogin/Login';
import AvailabilityCheck from './App/components/PreLogin/AvailabilityCheck';
import PreLoginSearchResult from './App/components/PreLogin/SearchResult';
import GECustNetRegistration from './App/components/PreLogin/GECustNetRegistration';
import GECustNetRegistrationConfirmation from './App/components/PreLogin/GECustNetRegistration/confirmation';
import OppsNoAccount from './App/components/PreLogin/OppsNoAccount';
import RequestAccess from './App/components/PreLogin/RequestAccess';
import ForgotPassword from './App/components/PreLogin/ForgotPassword';
import RequestAccessConfirmation from './App/components/PreLogin/RequestAccess/confirmation';
import PunchOutTransferCart from './App/components/PreLogin/PunchoutTransferCart';

//Postlogin components
import App from './App/components/PostLogin/App';
import Home from './App/components/PostLogin/Home';
import SiteManagement from './App/components/PostLogin/SiteManagement';
import DeleteReturns from './App/components/PostLogin/SiteManagement/DeleteReturns';
import CreateTokenAccount from './App/components/PostLogin/SiteManagement/CreateTokenAccount';
import ManageAssets from './App/components/PostLogin/SiteManagement/ManageAssets';
import ManageAccounts from './App/components/PostLogin/SiteManagement/ManageAccounts';
import RebatesAndClaimForms from './App/components/PostLogin/SiteManagement/RebatesAndClaimForms';
import PriceExportMessage from './App/components/PostLogin/SiteManagement/PriceExportMessage';
import PriceSheetAdmin from './App/components/PostLogin/SiteManagement/PriceSheetAdmin';
import CreateEditAsset from './App/components/PostLogin/SiteManagement/ManageAssets/createEditAsset';
import CreateEditRebatesAndForms from './App/components/PostLogin/SiteManagement/RebatesAndClaimForms/createEditRebatesAndForms';
import CreateEditPriceExportMessage from './App/components/PostLogin/SiteManagement/PriceExportMessage/createEditPriceExportMessage';
import CreateEditPriceSheetAdmin from './App/components/PostLogin/SiteManagement/PriceSheetAdmin/createEditPriceSheetAdmin';
import UpdateUser from './App/components/PostLogin/UpdateUser';
import PostLoginSearchResult from './App/components/PostLogin/SearchResult';
import ManageOrders from './App/components/PostLogin/Order/manageOrders';
import BackOrders from "./App/components/PostLogin/Order/backOrders";
import ApproveReturns from './App/components/PostLogin/Order/approveReturns';
import ApproveReturnCreditRequest from './App/components/PostLogin/Order/approveReturnCreditRequest';
import RequestReturn from './App/components/PostLogin/Order/requestReturn';
import RequestReturnStep1 from './App/components/PostLogin/Order/requestReturnStep1';
import RequestReturnStep2 from './App/components/PostLogin/Order/requestReturnStep2';
import RequestReturnStep3 from './App/components/PostLogin/Order/requestReturnStep3';
import RequestCredit from './App/components/PostLogin/Order/RequestCredit/requestCredit';
import RequestCreditStep1 from './App/components/PostLogin/Order/RequestCredit/requestCreditStep1';
import RequestCreditAsIsPriceAdjustmentReview from './App/components/PostLogin/Order/RequestCredit/requestCreditAsIsPriceAdjustmentReview';
import RequestCreditAsIsPriceAdjustment from './App/components/PostLogin/Order/RequestCredit/requestCreditAsIsPriceAdjustment';
import RequestCreditStep2 from './App/components/PostLogin/Order/RequestCredit/requestCreditStep2';
import RequestCreditStep3 from './App/components/PostLogin/Order/RequestCredit/requestCreditStep3';
import RequestCreditStep4 from './App/components/PostLogin/Order/RequestCredit/requestCreditStep4';
import RequestCreditScrapPolicy from './App/components/PostLogin/Order/RequestCredit/requestCreditScrapPolicy';
import ViewRequests from './App/components/PostLogin/Order/viewRequests';
import ViewInvoices from './App/components/PostLogin/Invoices/viewInvoices';
import PreviousReturnAndCredit from './App/components/PostLogin/Order/previousReturnAndCredit';
import ProofOfDelivery from './App/components/PostLogin/Order/proofOfDelivery';
import CancelProducts from './App/components/PostLogin/Order/cancelProducts';
import CancelProductsConfirmation from './App/components/PostLogin/Order/cancelProductsConfirmation';
import UpdateBookedOrderConfirmation from './App/components/PostLogin/Order/updateBookedOrderConfirmation';
import UpdateBookedOrderConfirmationError from './App/components/PostLogin/Order/updateBookedOrderConfirmationError';
import QuickOrderForm from './App/components/PostLogin/Order/quickOrderForm';
import CompareProducts from './App/components/PostLogin/CompareProducts';
import OrderDetails from './App/components/PostLogin/Order/orderDetails';
import ViewRequestsOrderDetails from './App/components/PostLogin/Order/viewRequestsOrderDetails';
import ApproveNcrpOrderDetails  from './App/components/PostLogin/Order/approveNcrpOrderDetails';
import Packages from './App/components/PostLogin/Packages';
import CreatePackage from './App/components/PostLogin/Packages/createPackage';
import EditPackage from './App/components/PostLogin/Packages/editPackage';
import PackageConfirmation from './App/components/PostLogin/Packages/packageConfirmation';
import CarrierInfo from './App/components/PostLogin/CarrierInfo';
import LookUpSerialNo from './App/components/PostLogin/LookUpSerialNo';
import List from './App/components/PostLogin/List';
import Cart from './App/components/PostLogin/Cart';
import CreatePriceTags from './App/components/PostLogin/CreatePriceTags';
import Monogram from './App/components/PostLogin/Monogram';
import PrestigePif from './App/components/PostLogin/PrestigePif';
import GeDistributor from './App/components/PostLogin/GeDistributor';
import Performance from './App/components/PostLogin/Performance';
import MapGuidelines from './App/components/PostLogin/Resources/MapGuidelines';
import BrandGuidelines from './App/components/PostLogin/Resources/BrandGuidelines';
import Bulletins from './App/components/PostLogin/Resources/Bulletins';
import ClaimForms from './App/components/PostLogin/Resources/ClaimForms';
import FullCatalog from './App/components/PostLogin/Resources/FullCatalog';
import PriceSheets from './App/components/PostLogin/Resources/PriceSheets';
import AdvertisingPortal from './App/components/PostLogin/Resources/AdvertisingPortal';
import RequestProductAndPrice from './App/components/PostLogin/Resources/RequestProductAndPrice';
import SalesAgreementHandbook from './App/components/PostLogin/Resources/SalesAgreement/salesAgreementHandbook';
import ProductPurchaseReport from './App/components/PostLogin/ProductPurchaseReport';
import Help from './App/components/PostLogin/Help';
import HelpDesk from './App/components/PostLogin/HelpDesk';
import PartsNetQuickOrderForm from './App/components/PostLogin/Order/partsNetQuickOrderForm';
import PartsNetCart from './App/components/PostLogin/Cart/partsNetCart';
import PartsNetCheckout from './App/components/PostLogin/Order/partsNetCheckout';
import PartsNetOrderDetails from './App/components/PostLogin/Order/partsNetOrderDetails';
import PartsNetOrderConfirmation from './App/components/PostLogin/Order/partsNetOrderConfirmation';
import NonGEASSOUsers from './App/components/PostLogin/SiteManagement/NonGEASSOUsers';
import PartsNetPriceSheets from './App/components/PostLogin/Resources/PriceSheets/partsNetPriceSheets';
import FileUploads from './App/components/PostLogin/SiteManagement/FileUploads';
import BulkUserAccount from './App/components/PostLogin/SiteManagement/BulkUserAccount';

/* Create Order Pages*/
import CreateOrder from './App/components/PostLogin/Order/createOrder';
import EditOrder from './App/components/PostLogin/Order/editOrder';
import OrderReview from './App/components/PostLogin/Order/orderReview';
import UpdateBookedOrder from './App/components/PostLogin/Order/updateBookedOrder';
import PayByCreditCard from './App/components/PostLogin/Order/payByCreditCard';

/* my profile pages*/
import Profile from './App/components/PostLogin/Profile';
import MyProfile from './App/components/PostLogin/Profile/MyProfile';
import ManageUsers from './App/components/PostLogin/Profile/ManageUsers';
import ManageUsersPage2 from './App/components/PostLogin/Profile/ManageUsersPage2';
import UserRequests from './App/components/PostLogin/Profile/UserRequests';

/*Brochure Pages Routes*/
import BrochureStep1 from './App/components/PostLogin/Brochure/step1';
import BrochureStep2 from './App/components/PostLogin/Brochure/step2';
import BrochureStep3 from './App/components/PostLogin/Brochure/step3';
import BrochureStep4 from './App/components/PostLogin/Brochure/step4';
import BrochureConfirmation from './App/components/PostLogin/Brochure/confirmation';
import SavedBrochures from './App/components/PostLogin/Brochure/savedBrochures';

/*Saved template and create new template*/
import SavedExports from './App/components/PostLogin/Exports/savedExports';
import CreateNewTemplate from './App/components/PostLogin/Exports/createNewTemplate';

/*Binder Pages Routes*/
import BinderStep1 from './App/components/PostLogin/Binders/step1';
import BinderStep2 from './App/components/PostLogin/Binders/step2';
import BinderConfirmation from './App/components/PostLogin/Binders/confirmation';

/*Training Routes*/
import Training from './App/components/PostLogin/Training';

//Common components
import RouteNotFound from './App/components/PageNotFound';
import PDFViewer from './App/components/common/PDFViewer';
import ProductSpecPage from './App/components/common/ProductSpecPage';
import ErrorPage from './App/components/common/ErrorPage';
import CreateWorkOrder from './App/components/PostLogin/Order/createWorkOrder';
import PartsNetRequestReturnStep2 from './App/components/PostLogin/Order/partsNetRequestReturnStep2';
import NCRPOrderForm from './App/components/PostLogin/Order/ncrpOrderForm';
import ApproveNcrpForm from './App/components/PostLogin/Order/ApproveNcrpForm';
import NCRPOrderConfirmation from './App/components/PostLogin/Order/ncrpOrderConfirmation';
import { NCRP_ENABLED_SALES_AGREEMENT_TYPES } from './App/components/common/ncrpConstants';
import PartsNetSearchResult from './App/components/PostLogin/PartsNetSearchResult';
import UserSearch from './App/components/PostLogin/SiteManagement/UserSearch';
import CoreBoardItems from './App/components/PostLogin/SiteManagement/CoreBoardItems';
import LookUpCSO from './App/components/PostLogin/LookUpCSO';
import DpmRequestDetails from './App/components/PostLogin/SiteManagement/Dpm/dpmRequestDetails';
import DpmRequests from './App/components/PostLogin/SiteManagement/Dpm/dpmRequests';
import CompetitorDetails from './App/components/PostLogin/SiteManagement/Dpm/competitorDetails';

const Path = {
	QUICK_ORDER: 'quickorder',
	CART: 'cart',
	LIST: 'list',
	CREATE_ORDER: 'order/createOrder',
	ORDER_REVIEW: ':whichOrder/orderreview',
	ORDER_CONFIRMATION: 'order/confirmation',
	ORDER_DETAILS: 'orderdetails',
	REQUEST_RETURN_STEP_2: 'requestreturnstep2',
	PRICE_SHEETS: 'resources/pricesheets',
	NCRP_ORDER: 'ncrp-order',
	DPM_REQUESTS: 'siteManagement/dpm-requests',
	DPM_REQUEST_REVIEW: 'siteManagement/dpm-requests/:dpmRequestId'
}

const RouteWrapper = props => {
	const { selectedPriceSource, userDetails, addressList: addressListResponse } = useSelector(state => state.user);
	const isGEAPartsSalesAgreementSelected = selectedPriceSource.AGREEMENT_TYPE === 'GEA Parts';
	let isNCRPAllowed = false;
	let Page = null;
	if (selectedPriceSource.AGREEMENT_TYPE && NCRP_ENABLED_SALES_AGREEMENT_TYPES.includes(selectedPriceSource.AGREEMENT_TYPE.toUpperCase()) &&
		userDetails && addressListResponse && addressListResponse.responseObject && addressListResponse.responseObject.length &&
		!addressListResponse.responseObject.some(address => address.PURPOSE === 'SOLD_TO' && address.STATUS === 'A' && address.COUNTRY !== 'US')) {
		isNCRPAllowed = true;
	}

	switch (props.route.path) {
		case Path.QUICK_ORDER:
			Page = isGEAPartsSalesAgreementSelected ? PartsNetQuickOrderForm : QuickOrderForm;
			break;
		case Path.CART:
			Page = isGEAPartsSalesAgreementSelected ? PartsNetCart : Cart;
			break;
		case Path.LIST:
			Page = isGEAPartsSalesAgreementSelected ? RouteNotFound : List;
			break;
		case Path.CREATE_ORDER:
			Page = isGEAPartsSalesAgreementSelected ? PartsNetCheckout : CreateOrder;
			break;
		case Path.ORDER_REVIEW:
			Page = isGEAPartsSalesAgreementSelected ? PartsNetCheckout : OrderReview;
			break;
		case Path.ORDER_CONFIRMATION:
			Page = isGEAPartsSalesAgreementSelected ? PartsNetOrderConfirmation : RouteNotFound;
			break;
		case Path.REQUEST_RETURN_STEP_2:
			Page = isGEAPartsSalesAgreementSelected ? PartsNetRequestReturnStep2 : RequestReturnStep2;
			break;
		case Path.PRICE_SHEETS:
			Page = isGEAPartsSalesAgreementSelected ? PartsNetPriceSheets : PriceSheets;
			break;
		case Path.NCRP_ORDER:
			Page = isNCRPAllowed ? NCRPOrderForm : RouteNotFound;
			break;
		case Path.NCRP_ORDER:
			Page = isNCRPAllowed ? ApproveNcrpForm : RouteNotFound;
			break;
		case 'search-result/:typeOfSearch/:searchKeyword':
			Page = isGEAPartsSalesAgreementSelected ? PartsNetSearchResult : PostLoginSearchResult;
			break;
		case 'search-result/:typeOfSearch':
			Page = isGEAPartsSalesAgreementSelected ? RouteNotFound : PostLoginSearchResult;
	}

	return <Page {...props} />
};

const OrderDetailsRouteWrapper = props => {
	const { user: { selectedPriceSource, selectedAccountsAllPriceSources }, order } = useSelector(state => state);
	const priceSources = selectedAccountsAllPriceSources.responseObject || [];
	const isGEAPartsSalesAgreementSelected = selectedPriceSource.AGREEMENT_TYPE === 'GEA Parts';

	const orderSalesAgreementNumber = order.orderDetails && order.orderDetails.responseObject.P_OUT_HEADER_REC && order.orderDetails.responseObject.P_OUT_HEADER_REC.BLANKET_NUMBER;
	const orderSource = order.orderDetails && order.orderDetails.responseObject.P_OUT_HEADER_VAL_REC && order.orderDetails.responseObject.P_OUT_HEADER_VAL_REC.ORDER_SOURCE;
	return orderSource === 'NCRP' || (isGEAPartsSalesAgreementSelected && orderSalesAgreementNumber &&
							priceSources.some(priceSource => priceSource.AGREEMENT_NUMBER.toString() === orderSalesAgreementNumber.toString() &&
								priceSource.AGREEMENT_TYPE === 'GEA Parts')) ? <PartsNetOrderDetails {...props} /> : <OrderDetails {...props} />;
}

const LookUpCSOWrapper = props => {
	const { userDetails, approvedAccounts } = useSelector(state => state.user);
	const allowLookUpCSO = !userDetails.punchOutAccess && props.isResponsibilityExists("View Orders") && (!(userDetails.typeOfUser !== 'employee' || userDetails.isNonGEASsoUser) ||
		(approvedAccounts && approvedAccounts.responseObject && approvedAccounts.responseObject.length > 1));
	return allowLookUpCSO ? <LookUpCSO {...props} /> : <RouteNotFound {...props} />;
}

const DPMWrapper = props => {
	if (props.route.path === Path.DPM_REQUESTS) {
		return <DpmRequests {...props} />
	} else if (props.route.path === Path.DPM_REQUEST_REVIEW) {
		return <DpmRequestDetails {...props} />;
	}
}

ReactDOM.render((
	<Provider store={store}>
		<Router history={browserHistory}>

			{/* <Redirect from="/" to="/login" /> */}

			<Route path="/" component={PreLoginApp}>
				<IndexRoute component={Login} />
				<Route name="login" path="/login" component={Login} />
			</Route>

			<Route path="/punchoutTransferCart" component={PunchOutTransferCart}/>

			<Route path="/prelogin" component={PreLoginApp}>
				<Route path="search-result/:typeOfSearch" component={PreLoginSearchResult} />
				<Route path="product-specs/:typeOfSearch/:sku" component={ProductSpecPage} />
				<Route path="ge-custnet-registration" component={GECustNetRegistration} />
				<Route path="ge-custnet-registration/confirmation" component={GECustNetRegistrationConfirmation} />
				<Route name="no-account" path="no-account" component={OppsNoAccount} />
				<Route name="request-access" path="request-access" component={RequestAccess} />
				<Route name="forgot-password" path="forgotpassword" component={ForgotPassword} />
				<Route name="request-access-confirmation" path="request-access/confirmation" component={RequestAccessConfirmation} />
				<Route name="error" path="error" component={ErrorPage} />
				<Route path="/availabilityCheck" component={AvailabilityCheck} />
			</Route>

			<Route path="/" component={App}>
				<IndexRoute name="home" component={Home} />
				<Route path="home" component={Home} />
				<Route path="siteManagement" component={SiteManagement} />
				<Route path="siteManagement/manageAssets" component={ManageAssets} />
				<Route path="siteManagement/manageAccounts" component={ManageAccounts} />
				<Route path="siteManagement/rebatesAndClaimForms" component={RebatesAndClaimForms} />
				<Route path="siteManagement/priceExportMessage" component={PriceExportMessage} />
				<Route path="/siteManagement/priceSheetAdmin" component={PriceSheetAdmin}/>
				<Route path="siteManagement/deleteReturns" component={DeleteReturns} />
				<Route path="siteManagement/createTokenAccount" component={CreateTokenAccount} />
				<Route path="siteManagement/asset/:whichOperation" component={CreateEditAsset} />
				<Route path="siteManagement/rebatesAndClaimForms/:whichOperation" component={CreateEditRebatesAndForms} />
				<Route path="siteManagement/priceExportMessage/:whichOperation" component={CreateEditPriceExportMessage} />
				<Route path="siteManagement/priceSheetAdmin/:whichOperation" component={CreateEditPriceSheetAdmin} />
				<Route path="siteManagement/fileuploads" component={FileUploads} />
				<Route path="siteManagement/bulkUserAccount" component={BulkUserAccount} />
				<Route path="siteManagement/user-search" component={UserSearch} />
				<Route path="siteManagement/core-boardItems" component={CoreBoardItems} />
				<Route path="siteManagement/nonGEASSOUsers" component={NonGEASSOUsers} />
				<Route path="updateUser" component={UpdateUser} />
				<Route path="search-result/:typeOfSearch/:searchKeyword" component={RouteWrapper} />
				<Route path="search-result/:typeOfSearch" component={RouteWrapper} />
				<Route path="product-specs/:typeOfSearch/:sku" component={ProductSpecPage} />
				<Route path="manageorders" component={ManageOrders} />
				<Route path="approve-ncrp" component={ApproveNcrpForm} />
				<Route path="backOrders" component={BackOrders} />
				<Route path={Path.CREATE_ORDER} component={RouteWrapper} />
				<Route path={Path.ORDER_CONFIRMATION} component={RouteWrapper} />
				<Route path="order/createworkorder" component={CreateWorkOrder} />
				<Route path="order/editOrder" component={EditOrder} />
				<Route path="order/updatebookedorder" component={UpdateBookedOrder} />
				<Route path={Path.ORDER_REVIEW} component={RouteWrapper} />
				<Route path="order/payByCreditCard" component={PayByCreditCard} />
				<Route path="approvereturns" component={ApproveReturns} />
				<Route path="approvereturncreditrequest" component={ApproveReturnCreditRequest} />
				<Route path="requestreturn" component={RequestReturn} />
				<Route path="requestreturnstep1" component={RequestReturnStep1} />
				<Route path={Path.REQUEST_RETURN_STEP_2} component={RouteWrapper} />
				<Route path="requestreturnstep3" component={RequestReturnStep3} />
				<Route path="requestcredit" component={RequestCredit} />
				<Route exact path="requestcreditstep1" component={RequestCreditStep1} />
				<Route exact path="requestCreditAsIsPriceAdjustment" component={RequestCreditAsIsPriceAdjustment} />
				<Route exact path="requestCreditAsIsPriceAdjustmentReview" component={RequestCreditAsIsPriceAdjustmentReview} />
				<Route exact path="requestcreditstep2" component={RequestCreditStep2} />
				<Route exact path="requestcreditstep3" component={RequestCreditStep3} />
				<Route exact path="requestcreditstep4" component={RequestCreditStep4} />
				<Route exact path="requestCreditScrapPolicy" component={ RequestCreditScrapPolicy } />
				<Route path="viewrequests" component={ViewRequests} />
				<Route path="viewinvoices" component={ViewInvoices} />
				<Route path="previousreturnandcredit" component={PreviousReturnAndCredit} />
				<Route path="proofofdelivery" component={ProofOfDelivery} />
				<Route path={Path.NCRP_ORDER} component={RouteWrapper} />
				<Route path='ncrp-order/confirmation' component={NCRPOrderConfirmation} />
				<Route path={Path.DPM_REQUESTS} component={DPMWrapper} />
				<Route path="partsorderdetails" component={PartsNetOrderDetails}/>
				<Route path={Path.DPM_REQUEST_REVIEW} component={DPMWrapper} />
				<Route path="siteManagement/competitor-details" component={CompetitorDetails} />
				<Route path="cancelproducts" component={CancelProducts} />
				<Route path=":whatDeleted/confirmation" component={CancelProductsConfirmation} />
				<Route path=":whichAction/bookedorder/confirmation" component={UpdateBookedOrderConfirmation} />
				<Route path=":whichAction/bookedorder/confirmationError" component={UpdateBookedOrderConfirmationError} />
				<Route path={Path.QUICK_ORDER} component={RouteWrapper} />
				<Route path={Path.ORDER_DETAILS} component={OrderDetailsRouteWrapper} />
				<Route path="viewrequestsorderdetails" component={ViewRequestsOrderDetails} />
				<Route path="approvencrporderdetails" component={ApproveNcrpOrderDetails} />
				<Route path="packages" component={Packages} />
				<Route path="createpackage" component={CreatePackage} />
				<Route path="editpackage" component={EditPackage} />
				<Route path="package/:whichtype/confirmation" component={PackageConfirmation} />
				<Route path="compare-products/:typeOfSearch/:searchKeyword/:skus" component={CompareProducts} />
				<Route path="carrierinformation" component={CarrierInfo} />
				<Route path="lookupserialno" component={LookUpSerialNo} />
				<Route path="lookupcso" component={LookUpCSOWrapper} />
				<Route path={Path.LIST} component={RouteWrapper} />
				<Route path={Path.CART} component={RouteWrapper} />
				<Route path=":pageName/help" component={Help} />
				<Route path="helpdesk" component={HelpDesk} />
				<Route path="createpricetags" component={CreatePriceTags} />
				<Route path="create-brochure-step1" component={BrochureStep1} />
				<Route path="create-brochure-step2" component={BrochureStep2} />
				<Route path="create-brochure-step3" component={BrochureStep3} />
				<Route path="create-brochure-step4" component={BrochureStep4} />
				<Route path="brochure/:what/confirmation" component={BrochureConfirmation} />
				<Route path="create-binder-step1" component={BinderStep1} />
				<Route path="create-binder-step2" component={BinderStep2} />
				<Route path="binder/:type/confirmation" component={BinderConfirmation} />
				<Route path="training" component={Training} />
				<Route path="savedbrochures" component={SavedBrochures} />
				<Route path="pdf-viewer" component={PDFViewer} />
				<Route path="saved-exports" component={SavedExports} />
				<Route path="price-template/:typeOfOperation" component={CreateNewTemplate} />
				<Route path="resources/monogram" component={Monogram} />
				<Route path="resources/prestigepif" component={PrestigePif} />
				<Route path="resources/gedistributor" component={GeDistributor} />
				<Route path="resources/performance" component={Performance} />
				<Route path="resources/mapguidelines" component={MapGuidelines} />
				<Route path="resources/brandguidelines" component={BrandGuidelines} />
				<Route path="resources/bulletins" component={Bulletins} />
				<Route path="resources/fullcatalog" component={FullCatalog} />
				<Route path="resources/claimforms" component={ClaimForms} />
				<Route path="resources/AdvertisingPortal" component={AdvertisingPortal}/>
				<Route path={Path.PRICE_SHEETS} component={RouteWrapper} />
				<Route path="resources/salesHandbooks" component={SalesAgreementHandbook} />
				<Route path="product-purchase-report" component={ProductPurchaseReport} />
				<Redirect from="profile/" to="profile/myProfile" />
				<Route path="profile/" component={Profile}>
					<Route path="myProfile" component={MyProfile} />
					<Route path="manageUsers" component={ManageUsers} />
					<Route path="manageUsersPage2/:sso" component={ManageUsersPage2} />
					<Route path="userRequests" component={UserRequests} />
					<Route path="*" component={MyProfile} />
				</Route>
				<Route path="request-product-price-content" component={RequestProductAndPrice} />
				<Route name="error" path="error" component={ErrorPage} />
				<Route name="noRoute" path="*" component={RouteNotFound} />
			</Route>
		</Router>
	</Provider>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js